<div class="container-espacios">
  <h3 class="titulo-listar-espacios">Espacios</h3>
  <div class="container-listar-espacios" [class.lista-filtro]="reservaEspacios">
    <div *ngFor="let espacio of espacios" class="container-espacio" [class.espacio-seleccionado]="idEspacioSeleccionado === espacio.id" (click)="reservaEspacios && seleccionarEspacio(espacio)">
      <img src={{espacio.picture}} alt="Imagen Espacio" class="imagen-espacio">
      <span> {{espacio.site_name}} </span>
      <button mat-icon-button [matMenuTriggerFor]="menu" class="opciones-espacio" (click)="$event.stopPropagation()">
        <img [src]="opciones" alt="Opciones">
      </button>
      <mat-menu #menu="matMenu" xPosition="before">
        <button mat-menu-item (click)="handleEditar(espacio.id)">
          <mat-icon>edit</mat-icon>
          <span>Editar</span>
        </button>
      </mat-menu>
    </div>
  </div>
</div>

